import styles from './CodePanel.module.scss';

import { ScrollPanel } from 'primereact/scrollpanel';
import { InputSwitch } from 'primereact/inputswitch';
import { useEffect, useState } from 'react';
import { useLazyGetCatalogQuery } from '../../libraries/DataLibrarySlice';
import { useLazyGetDebugDeploymentQuery } from '../../../app/apiSlice';
import { useGraph } from '../../../hooks/useGraph';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../hooks/hooks';
import { RadioButton } from 'primereact/radiobutton';

export const CodePanel = () => {

  const {render} = useGraph();
  const {t} = useTranslation();
  const topology = useAppSelector((state) => state.editor.current);
  const [dag, setDag] = useState<Object>();
  const [displayKflow, setDisplayKflow] = useState(false);
  const [getCatalog, {data: catalog,}] = useLazyGetCatalogQuery();
  const [getDebugDeployment, {data: kflowBody}] = useLazyGetDebugDeploymentQuery();

  useEffect(() => {
      if (topology) {
          if (!catalog) {
              getDebugDeployment({topologyID: topology.id});
              getCatalog({runtimeType: topology.runtimeMode}, true)
          } else {
              setDag(
                  render({
                      hidePassword: true,
                      catalog: catalog,
                  })
              );
          }
      }
  }, [topology, catalog]);

  const DisplayDagOrKflowBody = () => {
    const displayData = displayKflow ? kflowBody : dag;
    if (displayData) {
        return <pre>{JSON.stringify(displayData, undefined, 2)}</pre>
    } else {
        return <div><h1>{t('message.debug-error')}</h1></div>;
    }
  }

  return (
    <div className={styles['code-panel']}>
      <div className={styles['format-option']}>
        <span>Format : </span>
        <RadioButton
          inputId="formatKFlow"
          name="format"
          value="kflow"
          onChange={() => {setDisplayKflow(true)}}
          checked={displayKflow === true}
        />
        <label htmlFor="formatKFlow">{'KFlow'}</label>
        <RadioButton
          inputId="formatDag"
          name="format"
          value="dag"
          onChange={() => {setDisplayKflow(false)}}
          checked={displayKflow === false}
        />
        <label htmlFor="formatDag">{'Dag'}</label>
      </div>
      <div className={styles['data']}>
        <DisplayDagOrKflowBody />
      </div>
    </div>
  )
}